import React, { Component } from "react";

//Import Breadcrumb
import RCDisplayPage from "../../components/Common/RCDisplayPage";
//Constants
import { API_WEB_URLS } from "../../constants/constAPI";
//Store


import {
  Fn_FillListData,
  togglemodal,
  toggleDeleteConfirm,
  toggleDeleteSuccess,
  Fn_DeleteData,
  Fn_GetReport,
  Fn_AddEditData,
  Fn_ChangeStateValue,
  Fn_ExportExcel
} from "../../store/functions";

import {
  Container,
  Row,
  Col,
  Form,
  FormGroup,
  Input,
  Card,
  CardBody,
  CardTitle,
  CardSubtitle,
  Button,
  Label,
  Alert,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Modal
} from "reactstrap";
import SweetAlert from "react-bootstrap-sweetalert"

import {
  AvForm,
  AvField,AvRadioGroup,AvRadio
} from "availity-reactstrap-validation";

import { compose } from "recompose";
import { container } from "../../store/Containers/cntCommon";

import Breadcrumbs from "../../components/Common/Breadcrumb";
import '../Masters/datatables.scss';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory, {
  PaginationProvider, PaginationListStandalone,
  SizePerPageDropdownStandalone
} from 'react-bootstrap-table2-paginator';
import { API_HELPER } from "helpers/ApiHelper";

import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import * as XLSX from 'xlsx';



function getCurrentDate() {
  const currentDate = new Date();
  const year = currentDate.getFullYear();
  const month = String(currentDate.getMonth() + 1).padStart(2, '0'); // Month is 0-indexed
  const day = String(currentDate.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
}
class pageList_PendingCharges extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      selectedFormData: {},
      gridData: [],
      confirm_alert: false,
      formData : {},
      success_msg: false,
      dynamic_title: "",
      dynamic_description: "",
      company : [],
      page: 1,
      sizePerPage: 10,
      productData: [],
      RReason : '',
      F_RetailerComission : 0,
      F_DistributorComission : 0,
      F_SDistributorComission : 0,
      F_MDistributorComission : 0,
      Charges : 0,
      commissionmodal : false,
      success_dlg : false,
      confirm_undorefund : false,
      title : '',
      UTR : '',
      loading : false,
      selectedIds : [],
      PendingOffline : [{
        Id : 0
      }]

    };
    this.obj = this;
    this.breadCrumbTitle = "Masters";
    this.breadCrumbItem = "Pending Charges";
    this.modalTitle = "Audit Attendance";
    this.rtPage_Add = "add-customermaster";
    this.rtPage_Edit = "edit-customermaster";
    this.API_URL = "DMRTran/0/token";
    

    //Event Binding
    
    this.btnSave_onClick =  this.btnSave_onClick.bind(this);
   
   
    this.exportToExcel  = this.exportToExcel.bind(this);
    this.refresh  = this.refresh.bind(this);
    this.checkmerge  = this.checkmerge.bind(this);
    this.proceedmerge  =  this.proceedmerge.bind(this);

  }

   
  exportToExcel = () => {

    // let vformData = new FormData();
    
    // vformData.append("FromDate", this.state.FromDate);
    // vformData.append("ToDate",  this.state.ToDate);
    
    // Fn_ExportExcel(this.obj, { arguList: { id: 0, formData: vformData } }, "DMRExcel/0/token", "DMRTransaction", true);
    
const obj = JSON.parse(sessionStorage.getItem("authUser"));



    const orderAndFilter = (arr) => {
    return arr.map((item) => {

  
       return {
        Id: item.Id,
        TransactionDate: item.TransactionDate || item.DateOfCreation,
        TransactionCode: item.TransactionCode,
        AccountHolderName: item.AccountHolderName,
        SenderMobileNo: item.SenderMobileNo,
        AccountNo: item.AccountNo,
        BankName: item.BankName,
        IFSC: item.IFSC,
        Mode: item.Mode,
        Amount: item.Amount,
        Charges: item.Charges,
        ChargeTaken: item.ChargeTaken
    }
    });
  };
  
  // Apply the order and filter function to your original array
  const orderedAndFilteredArray = orderAndFilter(this.state.productData);


    const worksheet = XLSX.utils.json_to_sheet(orderedAndFilteredArray);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'FundRequest');
    XLSX.writeFile(workbook, `FundRequest.xlsx`);


  };

 



  componentDidMount() {
    this.refresh();
  }

  btnSave_onClick (event, formData)  {

    this.setState({loading : true })

    const obj = JSON.parse(sessionStorage.getItem("authUser"));

    this.setState({FromDate : formData.FromDate ,ToDate : formData.ToDate })

    let vformData = new FormData();
   
    vformData.append("From", formData.FromDate);
    vformData.append("To", formData.ToDate);
   
    Fn_GetReport(this.obj, { arguList: { id: obj.uid, formData: vformData } }, this.API_URL, "productData", true);
    this.setState({loading : false })
  }

  refresh = async () => {
    this.setState({ productData: [] });

    try {
      // 1. Sync live DMT records from RSeva for Retailer 213 (Shree Momai Communication)
      await API_HELPER.apiPOST(API_WEB_URLS.BASE + "SyncRSevaDMT/0/token/213", {});
    } catch (e) {
      console.warn("RSeva sync background check:", e);
    }

    // 2. Fetch all pending DMT records
    Fn_FillListData(
      this.obj,
      "productData",
      API_WEB_URLS.MASTER + "/0/token/AllPendingDMT/Id/0"
    );

    Fn_FillListData(
      this.obj,
      "PendingOffline",
      API_WEB_URLS.MASTER + "/0/token/PendingOffline/Id/0"
    );
  }


  proceedmerge (){
    
  const formattedIds = this.state.selectedIds.join(',');
     const vformData = new FormData();
        vformData.append("Ids", formattedIds);
        
    
        // Perform API call here
        Fn_AddEditData(
             this.obj,
             { arguList: { id: 0, formData: vformData } },
             "MergeDMT/0/token",
             "#",
             true,
             "VoucherId"
           );



           this.setState({  productData: []})

           Fn_FillListData(
             this.obj,
             "productData",
             API_WEB_URLS.MASTER + "/0/token/AllPendingDMT/Id/0"
           );
           alert('Successfully Merged')
  }


  checkmerge = (id) => {
    this.setState((prevState) => {
      const { selectedIds } = prevState;

      // Check if the ID already exists in the array
      if (selectedIds.includes(id)) {
        // If yes, remove it (unchecked)
        return { selectedIds: selectedIds.filter((item) => item !== id) };
      } else {
        // If no, add it (checked)
        return { selectedIds: [...selectedIds, id] };
      }
    });
  };
  



  
  render() {

    const obj = JSON.parse(sessionStorage.getItem("authUser"));
    const sumAmount = this.state.productData.reduce((total, row) => total + row.Amount, 0);

    const formatDateTime = (val) => {
      if (!val) return "-";
      const d = new Date(val);
      if (isNaN(d.getTime())) return val;
      const day = String(d.getDate()).padStart(2, '0');
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const year = d.getFullYear();
      let hours = d.getHours();
      const minutes = String(d.getMinutes()).padStart(2, '0');
      const seconds = String(d.getSeconds()).padStart(2, '0');
      const ampm = hours >= 12 ? 'PM' : 'AM';
      hours = hours % 12;
      hours = hours ? hours : 12;
      const strHours = String(hours).padStart(2, '0');
      return `${day}-${month}-${year} ${strHours}:${minutes}:${seconds} ${ampm}`;
    };

    // Helpers to classify transactions
    const isRefundFailed = (row) => {
      return (
        row.IsRefunded === 1 ||
        String(row.TransactionStatus).toUpperCase() === 'FAILED' ||
        String(row.TransactionAPIStatus).toLowerCase() === 'refunded' ||
        (row.RefundDate && !row.F_RefundedId && row.IsRefunded !== 2)
      );
    };

    const isRefundConsumed = (row) => {
      return (
        row.IsRefunded === 2 &&
        (String(row.TransactionStatus).toUpperCase() === 'FAILED' || row.RefundDate)
      );
    };

    const isRefundReissued = (row) => {
      return Boolean(row.F_RefundedId && row.F_RefundedId > 0);
    };

    const getRowHighlightClass = (row) => {
      if (isRefundFailed(row)) return 'table-row-failed-refund';
      if (isRefundConsumed(row)) return 'table-row-refund-consumed';
      if (isRefundReissued(row)) return 'table-row-refund-reissued';
      return '';
    };

    const getRowHighlightStyle = (row) => {
      if (isRefundFailed(row)) return { backgroundColor: '#fee2e2' };
      if (isRefundConsumed(row)) return { backgroundColor: '#fef3c7' };
      if (isRefundReissued(row)) return { backgroundColor: '#e0f2fe' };
      return {};
    };

    const columns = [
      {
        dataField: "action",
        text: "Check",
        formatter: (cellContent, row) => {
          const disabled = isRefundFailed(row);
          return (
            <input
              type="checkbox"
              disabled={disabled}
              title={disabled ? "Refunded transaction cannot be merged" : "Select to merge"}
              className="btn btn-success btn-xs"
              checked={this.state.selectedIds.includes(row.Id)}
              onChange={() => this.checkmerge(row.Id)}
            />
          );
        },
      },
      {
        dataField: 'TransactionDate',
        text: 'Date / Time',
        sort: true,
        formatter: (cellContent, row) => formatDateTime(row.TransactionDate || row.DateOfCreation),
        footer: columnData => (
          <div></div>
        )
      },
      {
        dataField: 'SenderMobileNo',
        text: 'Sender Mobile No',
        sort: true,
        formatter: (cellContent, row) => (row.SenderMobileNo && row.SenderMobileNo !== 0 && row.SenderMobileNo !== "0") ? row.SenderMobileNo : "-",
        footer: columnData => (
          <div></div>
        )
      },

  
    {
      dataField: 'AccountNo',
      text: 'AccountNo',
      sort: true,
      formatter: (cellContent, row) => (row.AccountNo && row.AccountNo !== "") ? row.AccountNo : (row.Mode === "IndoNepal" || row.Remarks === "IND" ? <span className="badge bg-light text-secondary">Cash Remittance</span> : "-"),
      footer: columnData => (
        <div>
         
        </div>
      )
    } ,
    {
      dataField: 'TransactionCode',
      text: 'TransactionCode',
      sort: true,
      formatter: (cellContent, row) => {
        return (
          <div>
            <span>{row.TransactionCode || "-"}</span>
            {isRefundFailed(row) && (
              <span className="badge bg-danger text-white ms-2 font-size-11">
                <i className="mdi mdi-alert-circle me-1"></i> FAILED / REFUND
              </span>
            )}
            {isRefundConsumed(row) && (
              <span className="badge bg-warning text-dark ms-2 font-size-11">
                REFUND CONSUMED
              </span>
            )}
            {isRefundReissued(row) && (
              <span className="badge bg-info text-white ms-2 font-size-11">
                RE-ISSUED (#{row.F_RefundedId})
              </span>
            )}
          </div>
        );
      },
      footer: columnData => (
        <div>
         
        </div>
      )
    } ,
    
     {
      dataField: 'Amount',
      text: 'Amount',
      sort: true,
      footer: columnData => (
        <div>
         
        </div>
      )
    },
    {
      dataField: 'Charges',
      text: 'Charges',
      sort: true,
      footer: columnData => (
        <div>
         
        </div>
      )
     
    },
    {
      dataField: 'AccountHolderName',
      text: 'AccountHolderName',
      sort: true,
      footer: columnData => (
        <div>
         
        </div>
      )
    },
    {
      dataField: 'BankName',
      text: 'BankName',
      sort: true,
      formatter: (cellContent, row) => {
        const isIndo = row.Mode === 'IndoNepal' || row.Remarks === 'IND' || (row.BankName && row.BankName.toLowerCase().includes('indo'));
        return (
          <div className="d-flex align-items-center">
            <span>{row.BankName || '-'}</span>
            {isIndo && <span className="badge bg-info text-white ms-2 font-size-11">Indo-Nepal</span>}
          </div>
        );
      },
      footer: columnData => (
        <div>
         
        </div>
      )
    },
    {
      dataField: "action",
      text: "Proceed",
      formatter: (cellContent, row) => {
        return (
          <button
          type="button"
          //disabled={row.IsRefund? true : false}
            className="btn btn-success btn-xs"
            onClick={() => 
              this.props.history.push('/chargesentry/'+row.Id)
             
            }
          >
            <i className="mdi mdi-printer font-size-18 mr-3" id="edittooltip"></i>
          </button>
        );
      },
    } 
    
  
  ];

  const defaultSorted = [{
    dataField: 'id',
    order: 'asc'
  }];

  const pageOptions = {
    sizePerPage: 10,
    totalSize: this.state.productData.length, // replace later with size(customers),
    custom: true,
  }

  // Custom Pagination Toggle
  const sizePerPageList = [
    { text: '5', value: 5 },
    { text: '10', value: 10 },
    { text: '15', value: 15 },
    { text: '20', value: 20 },
    { text: '25', value: 25 },
    { text: 'All', value: (this.state.productData).length }];


  // Select All Button operation
  const selectRow = {
    mode: 'checkbox'
  }

  const { SearchBar } = Search;

    return (




     <>

<React.Fragment>
        <div className="page-content">
      
          <Container fluid>
            {/* Render Breadcrumb */}
            <Breadcrumbs
              title={this.breadCrumbTitle}
              breadcrumbItem={this.breadCrumbItem}
            />
           

                         <Row>
              <Col className="col-12">
                <Card>
                  <CardBody>
                    <PaginationProvider
                      pagination={paginationFactory({
                        ...pageOptions,
                        sizePerPageList: [
                          { text: '25', value: 25 },
                          { text: '50', value: 50 },
                          { text: '100', value: 100 },
                        ],
                      })}
                      keyField='id'
                      columns={columns}
                      data={this.state.productData}
                    >
                      {({ paginationProps, paginationTableProps }) => (
                        <ToolkitProvider
                          keyField='id'
                          columns={columns}
                          data={this.state.productData}
                          search
                        >
                          {toolkitProps => (
                            <React.Fragment>

                              <Row className="mb-2">
                                <Col md="4">
                                  <div className="search-box me-2 mb-2 d-inline-block">
                                    <div className="position-relative">
                                      <SearchBar
                                        {...toolkitProps.searchProps}
                                      />
                                      <i className="bx bx-search-alt search-icon" />
                                    </div>
                                  </div>
                                </Col>
                                <Col md="4">
                                     <Button
                                                            type="button"
                                                            color="primary"
                                                            onClick={this.refresh}
                                                            className="mr-1 waves-effect waves-light"
                                                          >
                                                            Refresh 
                                                          </Button>
                                                         
                                                          
                                </Col>
                                <Col>
                                <h5 style={{color:'red'}}>
                                                          {'('+this.state.PendingOffline[0].Id+')' + ' Pending Offline'} 
                                                          </h5>
                                </Col>
                                {/* <Col md="4">
                                <Button
                          type="button"
                          color="primary"
                          style={{marginLeft:10}}
                          onClick={this.proceedmerge}
                          className="mr-1 waves-effect waves-light"
                        >
                          Merge  
                        </Button>
                                </Col> */}
                              </Row>

                              <Row>
                                <Col xl="12">
                                  <div className="table-responsive">
                                    <BootstrapTable
                                      keyField={"id"}
                                      responsive
                                      bordered={false}
                                      striped={false}
                                      defaultSorted={defaultSorted}
                                     // selectRow={selectRow}
                                      classes={
                                        "table align-middle table-nowrap"
                                      }
                                      headerWrapperClasses={"thead-light"}
                                      rowClasses={getRowHighlightClass}
                                      rowStyle={getRowHighlightStyle}
                                      {...toolkitProps.baseProps}
                                      {...paginationTableProps}
                                    />

                                  </div>
                                </Col>
                              </Row>

                              <Row className="align-items-md-center mt-30">
                                <Col className="inner-custom-pagination d-flex">
                                  <div className="d-inline">
                                    <SizePerPageDropdownStandalone
                                      {...paginationProps}
                                    />
                                  </div>
                                  <div className="text-md-right ms-auto">
                                    <PaginationListStandalone
                                      {...paginationProps}
                                    />
                                  </div>
                                </Col>
                              </Row>
                            </React.Fragment>
                          )
                          }
                        </ToolkitProvider>
                      )
                      }</PaginationProvider>
                  </CardBody>
                </Card>
              </Col>
              </Row>





                         
                         </Container>

                         </div>
                         </React.Fragment>



  </>
    );
  }
}
export default compose(container)(pageList_PendingCharges);
